// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3NUX17vWvsNcCmj-9xaaZN {\r\n    display: flex;\r\n    align-items: center;\r\n    margin: 12px 0 24px 0;\r\n}\r\n\r\n._9X54KjQ2ut7tASaWXceH2 {\r\n    font-size: var(--font-size-m);\r\n    color: #fff;\r\n    font-weight: bold;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    flex: 1;\r\n    white-space: nowrap;\r\n\r\n}", ""]);
// Exports
exports.locals = {
	"container": "_3NUX17vWvsNcCmj-9xaaZN",
	"email": "_9X54KjQ2ut7tASaWXceH2"
};
module.exports = exports;
